export default {
  empty: {
    en: 'Nothing to show',
  },
}
